import { render, staticRenderFns } from "./index.bak01.vue?vue&type=template&id=6a334c34&scoped=true&"
import script from "./index.bak01.vue?vue&type=script&lang=js&"
export * from "./index.bak01.vue?vue&type=script&lang=js&"
import style0 from "./index.bak01.vue?vue&type=style&index=0&id=6a334c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a334c34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a334c34')) {
      api.createRecord('6a334c34', component.options)
    } else {
      api.reload('6a334c34', component.options)
    }
    module.hot.accept("./index.bak01.vue?vue&type=template&id=6a334c34&scoped=true&", function () {
      api.rerender('6a334c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trial/record/index.bak01.vue"
export default component.exports